import { resourceExplorerDataSelector } from "./resourceExplorerDataSelector";
import { RootState } from "../../../../store";

export const resourceExplorerGroupValuesSelector = (state: RootState) => {
  const data = resourceExplorerDataSelector(state);

  return data?.group_values;
};
